import React, { useState } from 'react';
import styled from 'styled-components';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { Form, Input, Upload, message, Typography, Space } from 'antd';

import { getTranslatedString } from 'helpers/i18n';

const { Title } = Typography;

const StyledSpace = styled(Space)`
  width: 100%;
  position: relative;
`;

export const DisplayOnlyBlockFields = ({ form, originalImageUrl = null }) => {
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState(originalImageUrl);

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 20;
    if (!isLt2M) {
      message.error('Image must smaller than 20MB!');
    }
    return isJpgOrPng && isLt2M;
  };

  const handleChange = (info) => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }
    if (info.file.status === 'done') {
      setLoading(false);
      form.setFieldsValue({ file_upload_id: info.file.response.file_upload.id });
      setImageUrl(info.file.response.file_upload.url);
    }
  };

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        {getTranslatedString(
          'landlordPortal.applicationManagement.applicationOverview.applicants.insurance.upload'
        )}
      </div>
    </div>
  );

  return (
    <>
      <Title level={5}>
        {getTranslatedString('landlordPortal.applicationTemplate.prototypesDrawer.displayImage')}
      </Title>

      <StyledSpace direction="vertical" size="middle">
        <Form.Item name="file_upload_id">
          <Upload
            name="upload"
            action={`http://api.localhost/v1/file_uploads`}
            listType="picture-card"
            showUploadList={false}
            maxCount={1}
            beforeUpload={beforeUpload}
            onChange={handleChange}
          >
            {imageUrl ? (
              <img
                src={imageUrl}
                alt="uploaded-file"
                style={{
                  width: '100%',
                }}
              />
            ) : (
              uploadButton
            )}
          </Upload>
        </Form.Item>

        <Form.Item
          name="image_caption"
          label={getTranslatedString(
            'landlordPortal.applicationTemplate.prototypesDrawer.imageCaption'
          )}
          requiredMark={'optional'}
        >
          <Input type="text" />
        </Form.Item>

        <Form.Item
          name="image_alt"
          label={getTranslatedString(
            'landlordPortal.applicationTemplate.prototypesDrawer.imageAlt'
          )}
          requiredMark={'optional'}
        >
          <Input type="text" />
        </Form.Item>

        <Form.Item
          name="image_href"
          label={getTranslatedString(
            'landlordPortal.applicationTemplate.prototypesDrawer.imageHref'
          )}
          requiredMark={'optional'}
        >
          <Input type="text" />
        </Form.Item>
      </StyledSpace>
    </>
  );
};

export default DisplayOnlyBlockFields;
